import { useMutation } from "@tanstack/react-query";
import { handleError } from "@/api/error";
import { queryClient } from "@/providers/QueryClientProviderWrapper";
import { client } from "../client";

type DeleteLarkWebhookClientPayload = {
  id: string;
  merchantId: string;
};

export const useDeleteLarkWebhookClient = () => {
  return useMutation({
    mutationFn: async (payload: DeleteLarkWebhookClientPayload) => {
      const res = await client.admin["lark-webhook-clients"][":merchantId"][":id"].$delete({
        param: { merchantId: payload.merchantId, id: payload.id },
      });
      if (!res.ok) throw await handleError(res);
      return await res.json();
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["admin", "lark-webhook-clients", variables.merchantId],
      });
    },
  });
};
